<app-chart [options]="options" [series]="series"></app-chart>
